import { apiClient, clearToken, setToken } from './apiClient';

export async function register(data) {
  const response = await apiClient.post('/auth/register', data);
  if (response?.token) setToken(response.token);
  return response;
}

export async function login(data) {
  const response = await apiClient.post('/auth/login', data);
  if (response?.token) setToken(response.token);
  return response;
}

export async function me() {
  const response = await apiClient.get('/auth/me');
  return response.user;
}

export async function logout() {
  try {
    await apiClient.post('/auth/logout');
  } finally {
    clearToken();
  }
}
